import { gql } from '@apollo/client'

export const CREATE_CART_MUTATION = gql`
  mutation CreateCart($input: CreateCartInput!) {
    createCart(input: $input) {
      cartID
    }
  }
`
export const GET_CART_QUERY = gql`
  query CartResponse($cartID: String!) {
    cartResponse(cartID: $cartID) {
      cart {
        channelCode
        channelName
        displayChannelCode
        items {
          id
          arrival
          departure
          quantity
          maxAvailibility
          useAllocated
          ratePolicy
          occupancy {
            defaultOccupancy
            extraBeds
            children
            total
            adults
          }
          roomType {
            roomTypeCode
            displayRoomTypeCode
            name
            facilities
            images
          }
          ratePlan {
            ratePlanCode
            displayRatePlanCode
            name
            boardType
          }
          provider {
            providerCode
            displayProviderCode
            name
          }
          rateGroup {
            rateGroupCode
            name
          }
          price {
            beforeDiscount {
              roomPrice
              extraBedPrice
              totalAddOnesPrice
              totalPrice
            }
            afterDiscount {
              roomPrice
              extraBedPrice
              totalAddOnesPrice
              totalPrice
            }
          }
          pricePerDay {
            date
            price {
              beforeDiscount {
                roomPrice
                extraBedPrice
                totalPrice
                totalAddOnesPrice
              }
              afterDiscount {
                roomPrice
                extraBedPrice
                totalPrice
                totalAddOnesPrice
              }
            }
          }
          cancellationPolicy {
            id
            description
            name
            policies {
              applied
              priority
              penaltyAmount
              deadline
              deadlineTimeOffset
              penaltyType
              policyType
            }
          }
          modificationPolicy {
            id
            description
            name
            policies {
              applied
              priority
              penaltyAmount
              deadline
              deadlineTimeOffset
              penaltyType
              policyType
            }
          }
          availableAddOns {
            name
            code
            priceBeforeDiscount
            priceAfterDiscount
            totalPrice
            currency
            perPerson
            perNight
          }
          selectedAddOnes
          hash
        }
        accommodationInfo {
          propertyCode
          displayPropertyCode
          name
          city
          star
          images
        }
        paymentInfo {
          walletID
          walletType
          isBilateral
          cashBalance
          remainingCreditBalance
          currency
          creditorID
        }
      }
      cartUpdates {
        message
        itemID
        cartUpdatType
        cartUpdateReason
      }
      billingSummary {
        roomsPrice {
          quantity
          price
          roomTypeName
          ratePlanCode
          displayRatePlanCode
        }
        subTotalPrice {
          subTotalBeforeDiscount
          discount
          subTotalAfterDiscount
        }
        taxAndFees
        totalPayable
        curruncy
      }
    }
  }
`
export const ADD_ITEM_TO_CART_MUTATION = gql`
  mutation AddItemToCart($input: AddItemToCartInput!) {
    addItemToCart(input: $input) {
      message
      itemID
      cartUpdatType
      cartUpdateReason
    }
  }
`

export const REMOVE_ITEM_FROM_CART_MUTATION = gql`
  mutation RemoveItemFromCart($input: RemoveItemFromCartInput!) {
    removeItemFromCart(input: $input) {
      message
    }
  }
`

export const UPDATE_ITEM_QUANTITY_IN_CART_MUTATION = gql`
  mutation UpdateItemQuantityInCart($input: UpdateItemQuantityInCartInput!) {
    updateItemQuantityInCart(input: $input) {
      message
    }
  }
`
export const DELETE_CART_MUTATION = gql`
  mutation DeleteCart($cartID: String!) {
    deleteCart(cartID: $cartID) {
      message
    }
  }
`
export const RESET_CART_MUTATION = gql`
  mutation ResetCart($cartID: String!) {
    resetCart(cartID: $cartID) {
      message
    }
  }
`
export const ADD_ADDON_TO_CART_MUTATION = gql`
  mutation AddAddOnToItem($input: AddAddOnToItemInput!) {
    addAddOnToItem(input: $input) {
      message
    }
  }
`
export const REMOVE_ADDON_FROM_CART_MUTATION = gql`
  mutation RemoveAddOnFromItem($input: RemoveAddOnFromItemInput!) {
    removeAddOnFromItem(input: $input) {
      message
    }
  }
`
